export default __webpack_public_path__ + "static/media/portfolio-96.566da91a.jpg";